import Vue from 'vue'
import Router from 'vue-router'
import Acts from '@/components/acts'
import Page from '@/components/page'
import ActsSingle from '@/components/acts_single'

Vue.use(Router)

export default new Router({
  routes: [
    {
        path: '/',
        name: 'Home',
        component: Acts,
        //redirect: '/acts'

    },
    {
        path: '/acts',
        name: 'Acts',
        component: Acts
    },
    {
        path: '/acts/:id',
        name: 'Single act',
        component: ActsSingle,
        props: true,
    },
    {
        path: '/page/:slug',
        name: 'Page',
        component: Page,
        props: true,
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js